import { render, staticRenderFns } from "./ListPedidosTienda.vue?vue&type=template&id=40dac951"
import script from "./ListPedidosTienda.vue?vue&type=script&lang=js"
export * from "./ListPedidosTienda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports